import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  theme: 'light',
  isSidebarOpen: false,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setTheme(state, action) {
      state.theme = action.payload;
    },
    toggleSidebar(state) {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
  },
});

export const { setTheme, toggleSidebar } = appSlice.actions;
export default appSlice.reducer;


